import getWindow from './getWindow';
import getOffset from './getOffset';
export default (function (node, client) {
  var win = getWindow(node);

  if (win) {
    return win.innerHeight;
  }

  return client ? node.clientHeight : getOffset(node).height;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/es/query/getHeight.js
// module id = 2908
// module chunks = 31